import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

import Footer from "../../components/Footer/footer";
import HeaderComponent from "../../components/Header";
import "../../static/css/styles.css";
import { history } from "../../helpers/history";
import { Spring } from "react-spring";
import { counsellorActions, slotActions } from "../../store/actions";
import Loading from "../../components/Loading/Loading";
import DrLogo from "../../static/images/doctorLogo.png";
import wellbeingIcon from "../../static/images/wellbeing-counsellor.png";
import nutrionistIcon from "../../static/images/nutritionist-counsellor.png";
import Swal from "sweetalert2";
import { API_ROOT_URL } from "../../config";
import Modal from "../../components/Modal";
import { constants } from '../../Constants';
import { cnslrHistoryConst } from "../../helpers/ConstantID";
import './myCounsellor.css';

class MyCounsellor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      modalIndex: ''
    };
  }

  componentDidMount() {
    this.props.fetchMyCounsellor();
    this.props.fetchCounsellorList();
    this.props.getMultiCounsellor()
  }

  showPreviousSessions = (index) => {
    this.setState({
      showModal: !this.state.showModal,
      modalIndex: index
    });
  };

  deleteRelation = (counsellor_id) => {
    const { whitelabel } = this.props;
    const role = whitelabel && whitelabel[0] ? whitelabel[0].producer_role : constants.COUNSELLOR;
    Swal.queue([
      {
        title: "Are you sure?",
        text: `Confirming this action will delete relation with your current ${role}`,
        confirmButtonText: "Confirm",
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonColor: "#36A692",
        cancelButtonColor: "#C62E2E",
        showLoaderOnConfirm: true,
        onOpen: function () {
          Swal.getPopup().querySelector('.swal2-cancel').setAttribute('id', 'btnCancelTerminateRelation');
          Swal.getPopup().querySelector('.swal2-confirm').setAttribute('id', 'btnConfirmTerminateRelation');
        },
        preConfirm: () => {
          const token = JSON.parse(localStorage.getItem("token"));
          const requestOptions = {
            method: "DELETE",
            body: JSON.stringify({ counsellor_id }),
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + token
            }
          };
          return fetch(`${API_ROOT_URL}/relations/delete-single/`, requestOptions)
            .then(response => response.json())
            .then(data => {
              if (data.success) {
                Swal.insertQueueStep({
                  type: "success",
                  title: "Successfully deleted",
                  onOpen: function () {
                    Swal.getPopup().querySelector('.swal2-confirm').setAttribute('id', 'btnSuccessTerminateRelation');
                  },
                });
                let user = JSON.parse(localStorage.getItem("user"));
                let user_info = {
                  counsellor_id: null,
                  email_address: JSON.parse(localStorage.getItem("user")).email_address,
                  role: JSON.parse(localStorage.getItem("user")).role,
                  token: JSON.parse(localStorage.getItem("user")).token,
                  user_id: JSON.parse(localStorage.getItem("user")).user_id,
                  full_name: JSON.parse(localStorage.getItem("user")).full_name,
                  verified: true,
                  relation: null
                };
                localStorage.removeItem("user");
                localStorage.setItem("user", JSON.stringify(user_info));
                history.push("/home");
              } else if (data.error) {
                let error = data.error;
                if (error === 'You have future appointments with the counsellor')
                  error = ` You have future appointments with the ${role}`;
                Swal.insertQueueStep({
                  type: "error",
                  title: error,
                  onOpen: function () {
                    Swal.getPopup().querySelector('.swal2-confirm').setAttribute('id', 'btnCantTerminateRelation');
                  },
                })
                  ;
              }
            });
        }
      }
    ]);
  };

  render() {
    const { whitelabel, my_counsellor, multiCounsellor } = this.props;
    return (
      <div className="ContainerFix">
        <div className={this.state.showModal ? "modal-cover" : ""}></div>
        <HeaderComponent />
        <Spring from={{ transform: "translate(+100%, 0)" }} to={{ transform: "translate(0%, 0)" }}>
          {props => (
            <div className="containerFlex" style={props}>
              <div className="text-center welcome-text">
                HI {this.props.state.auth.user.full_name}
                <br />
                Good day!
              </div>
              <div className="counsellor-list-cards row counsellor-list-cards-container ">
                {multiCounsellor && multiCounsellor.length > 0 ? multiCounsellor.map((my_counsellor, index) => {
                  return (
                    <div className={`counsellor-list-card col-md-6 counsellor-list-card-container ${multiCounsellor.length === 1 ? 'max-width-single-view' : 'max-width-split-view'}`}>
                      <Modal onClose={this.showPreviousSessions} showModal={this.state.modalIndex === index} whitelabel={whitelabel} service_type_id={my_counsellor.service_type.id} />
                      <div className="counsellor-list-image-container">
                        <div className="image-inner-container">
                          <img src={my_counsellor.picture ? my_counsellor.picture : DrLogo} width="130px" height="130px" className="counsellor-photo" alt='' />
                          <img src={my_counsellor.service_type.code === 'wellbeing' ? wellbeingIcon : nutrionistIcon} className="counsellor-image-icon" />
                        </div>
                        <span className="counsellor-name">
                          {my_counsellor.full_name}
                        </span>
                      </div>

                      <div className="my-counsellor-inner-card overflow-auto inner-card-container" onClick={this.props.createAppointment}>
                        <div className="counsellor-card-text">
                          {" "}
                          I am your {whitelabel && whitelabel[0] ? whitelabel[0].producer_role : constants.COUNSELLOR}. My name is {my_counsellor.full_name.toUpperCase()}.
                          {my_counsellor.qualifications ? " I have completed " + my_counsellor.qualifications + "." : null}
                          {my_counsellor.qualifications && my_counsellor.area_of_expertise ? " Alongside this, " : null}
                          {my_counsellor.area_of_expertise ? " My main area of focus is " + my_counsellor.area_of_expertise + "." : null}
                        </div>
                      </div>
                      <span>
                        If you want to see your history of {my_counsellor.service_type.code === 'wellbeing' ? "Wellbeing" : "Nutritionist"} sessions, just{" "}
                        <div
                          id={cnslrHistoryConst.sh_pt_session_histroy}
                          className="my-counsellor-buttons"
                          onClick={e => {
                            this.showPreviousSessions(index);
                          }}
                        >
                          Click Here
                        </div>
                        If you want to schedule your session with another {my_counsellor.service_type.code === 'wellbeing' ? "Wellbeing" : "Nutritionist"} Counsellor, just{" "}
                        <div id={cnslrHistoryConst.sh_pt_cancel_relation} className="my-counsellor-buttons" onClick={() => this.deleteRelation(my_counsellor.id)}>
                          Click Here
                        </div>
                      </span>
                    </div>
                  )
                }) : (
                  <Loading />
                )}
              </div>
            </div>
          )}
        </Spring>
        <Footer />
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { user } = state.auth.user;
  const { whitelabel } = state.whitelabel;
  const { my_counsellor } = state.slots;
  const { multiCounsellor } = state.counsellorStatus;

  return {
    alert,
    user,
    my_counsellor,
    whitelabel,
    state,
    multiCounsellor
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchCounsellorList: () => {
      dispatch(slotActions.fetchCounsellorList());
    },
    fetchMyCounsellor: () => {
      dispatch(slotActions.fetchMyCounsellor());
    },
    getMultiCounsellor: () => {
      dispatch(
        counsellorActions.getMultiCounsellor()
      );
    },
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MyCounsellor));



// WEBPACK FOOTER //
// ./src/screens/MyCounsellor/index.js